import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Constants } from 'src/app/models/constants';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';

@Component({
  selector: 'app-add-custom-image.component',
  templateUrl: './add-custom-image.component.html',
  styleUrl: './add-custom-image.component.scss',
  standalone: false
})
export class AddCustomImageComponent implements OnInit {

  private destroyRef = inject(DestroyRef);

  @Input() components: any;
  @Input() edit = false;
  @Input() editData;
  selectedComponent: any;
  imageOccurrences: any[];
  index: number;
  formConfig: any;
  imageForm: FormGroup[] = [];
  componentForm: FormGroup;
  Constants = Constants;
  packageIndex: number;
  packageOccurrences: any[];
  packageForm: FormGroup[] = [];
  isLoading = false;
  filteredComponents: any;
  searchValue: any;


  constructor(public sidenavService: SidenavService, private formBuilder: FormBuilder,   private dialog: MatDialog, private toastrService: CustomToastrService) { }


  ngOnInit(): void {
    this.filteredComponents = this.components;
    const formConfig: any = {
      component: [undefined, [Validators.required]],
    };
    this.componentForm = this.formBuilder.group(formConfig);
    if (this.edit) {
      if (this.filteredComponents.find(item => item.name === this.editData?.component)) {
        this.componentForm.get('component').setValue(this.editData?.component);
      }
      this.addEditForm();
    }
  }

  // in edit flow, adding forms to show on UI for existing data
  addEditForm(): void {
    if (this.editData?.images?.length > 0) {
      this.editData.images?.forEach(item => {
        this.index = (this.index || this.index === 0) ? this.index + 1 : 0;
        this.createImageForm();
        const keys = Object.keys(this.formConfig);
        const values = item;
        keys.forEach(key => {
          if (values[key]) {
            this.imageForm[this.index].get(key).setValue(values[key]);
          }
        });
        this.imageOccurrences = this.imageOccurrences && this.imageOccurrences.length !== 0 ?
          [...this.imageOccurrences, this.imageOccurrences[this.imageOccurrences.length - 1] + 1] : [0];
      });
    }
    if (this.editData?.packages?.length > 0) {
      this.editData.packages?.forEach(item => {
        this.packageIndex = (this.packageIndex || this.packageIndex === 0) ? this.packageIndex + 1 : 0;
        this.createPackageForm();
        const keys = Object.keys(this.formConfig);
        const values = item;
        keys.forEach(key => {
          if (values[key]) {
            this.packageForm[this.packageIndex].get(key).setValue(values[key]);
          }
        });
        this.packageOccurrences = this.packageOccurrences && this.packageOccurrences.length !== 0 ?
          [...this.packageOccurrences, this.packageOccurrences[this.packageOccurrences.length - 1] + 1] : [0];
      });
    }
  }

  // assinging selected component
  selectionChanged(event): void {
    this.selectedComponent = event.value;
  }

  // closing popup
  closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }

  // adding image input row when add is clicked
  addImageOccurrence(): void {
    this.index = (this.index || this.index === 0) ? this.index + 1 : 0;
    this.createImageForm();
    this.imageOccurrences = this.imageOccurrences && this.imageOccurrences.length !== 0 ?
      [...this.imageOccurrences, this.imageOccurrences[this.imageOccurrences.length - 1] + 1] : [0];
  }

  // creating image form, a row record
  createImageForm(): void {
    this.formConfig = {
      name: ['', [Validators.required]],
      path: ['', [Validators.required]],
      version: ['', [Validators.required]],
    };
    this.imageForm[this.index] = this.formBuilder.group(this.formConfig);
  }

  // deleting image form when delete icon is clicked
  deleteImageOccurrence(i): void {
    this.imageOccurrences.splice(-1, 1);
    this.index = this.index - 1;
    this.imageForm.splice(i, 1);
    this.imageForm = this.imageForm;
  }

  // adding package input row when add is clicked
  addPackageOccurrence(): void {
    this.packageIndex = (this.packageIndex || this.packageIndex === 0) ? this.packageIndex + 1 : 0;
    this.createPackageForm();
    this.packageOccurrences = this.packageOccurrences && this.packageOccurrences.length !== 0 ?
      [...this.packageOccurrences, this.packageOccurrences[this.packageOccurrences.length - 1] + 1] : [0];
  }

  // creating package form, a row record
  createPackageForm(): void {
    this.formConfig = {
      name: ['', [Validators.required]],
      path: ['', [Validators.required]],
      version: ['', [Validators.required]],
    };
    this.packageForm[this.packageIndex] = this.formBuilder.group(this.formConfig);
  }

  // deleting package form when delete icon is clicked
  deletePackageOccurrence(i): void {
    this.packageOccurrences.splice(-1, 1);
    this.packageIndex = this.packageIndex - 1;
    this.packageForm.splice(i, 1);
    this.packageForm = this.packageForm;
  }

  // validating form inputs when submitted
   getDeployment(): any {
    let failed = false;
    if (!FormUtilService.validateForm(this.componentForm)) {
      return;
    }
    if (this.imageForm?.length === 0 && this.packageForm?.length === 0) {
      failed = true;
      setTimeout(() => {
        const title = translate('CUSTOM_IMAGES.ERROR');
        const message = translate('CUSTOM_IMAGES.ERROR_MESSAGE');
        this.toastrService.errMessage(message, title);
      }, 500);
    }
    this.imageForm.forEach(media => {
      if (media && !FormUtilService.validateForm(media)) {
        failed = true;
      }
    });
    this.packageForm.forEach(media => {
      if (media && !FormUtilService.validateForm(media)) {
        failed = true;
      }
    });
    if (failed) {
      return;
    } else {
      return this.componentForm.getRawValue();
    }
  }

  // getting form inputs when submitted
  createDeployment(): void {
    if (!this.getDeployment()) {
      return;
    }
    let imageList = [];
    this.imageForm.forEach(media => {
      imageList = [...imageList, media.getRawValue()];
    });
    const obj = this.getDeployment();
    obj.images = imageList;
    let packageList = [];
    this.packageForm.forEach(media => {
      packageList = [...packageList, media.getRawValue()];
    });
    obj.packages = packageList;
    this.sidenavService.closeRightSidenav(obj);

  }

  // resetting search filter of components dropdown when dropdown is closed
  resetFilter(): void {
    this.searchValue = undefined;
    this.filteredComponents = this.components;
  }

  // searching components dropdown
  searchChanged(value): void {
    this.filteredComponents = this.components.filter(item => item?.name?.toLowerCase().includes(value.toLowerCase()));
  }

  // resetting dropdown values when dropdown is closed
  dropdownClose(): void {
    if (this.filteredComponents?.length === 0) {
      this.filteredComponents = this.components;
    }
  }
}
